// ImageKit URL helpers. Endpoint matches the ImageKitProvider mounted in src/index.js.
export const IK_ENDPOINT = "https://ik.imagekit.io/ndshetunf";

// Accepts either a stored path ("/quran-school/blog/slug/cover.jpg")
// or an already-absolute ImageKit URL, and returns a transformed URL.
// transforms example: "w-800,q-80,f-auto"
export function ikUrl(src, transforms = "q-80,f-auto") {
  if (!src) return "";

  // Absolute ImageKit URL: inject/replace the tr: segment right after the endpoint.
  if (/^https?:\/\//i.test(src)) {
    if (!src.startsWith(IK_ENDPOINT)) return src; // foreign host, leave untouched
    const rest = src.slice(IK_ENDPOINT.length).replace(/^\/(tr:[^/]+\/)?/, "/");
    return `${IK_ENDPOINT}/tr:${transforms}${rest}`;
  }

  // Stored path
  const path = src.startsWith("/") ? src : `/${src}`;
  return `${IK_ENDPOINT}/tr:${transforms}${path}`;
}

// Responsive srcSet across widths, keeping any extra transforms (e.g. quality/format).
export function ikSrcSet(src, widths = [400, 800, 1200], extra = "q-80,f-auto") {
  if (!src) return "";
  return widths
    .map((w) => `${ikUrl(src, `w-${w},${extra}`)} ${w}w`)
    .join(", ");
}
